import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/subtitlePage.scss";

/**
 * SubtitlePage — MangoTV Subtitle Appearance Settings
 * Figma: Subtitle Appearance settings
 *
 * Layout:
 *   - Navbar (fixed top)
 *   - Breadcrumb: "Setting > Subtitle" (Setting is gray link, Subtitle is bold white)
 *   - Two-column: Left = settings card, Right = preview
 *   - Dark bg (#0a0a0a full page)
 *   - Footer below
 */

const SubtitlePage = () => {
  const navigate = useNavigate();
  const [font, setFont] = useState("Sans serif");
  const [fontSize, setFontSize] = useState("Normal");
  const [color, setColor] = useState("White");
  const [shadow, setShadow] = useState("Drop shadow");

  const handleSave = () => {
    // TODO: API call to save subtitle settings
  };

  const handleReset = () => {
    setFont("Sans serif");
    setFontSize("Normal");
    setColor("White");
    setShadow("Drop shadow");
  };

  return (
    <div className="subtitle-page">
      {/* Navbar */}
      <Navbar activeTab="Settings" />

      {/* Main Content */}
      <div className="subtitle-page__container">
        {/* Breadcrumb */}
        <div className="subtitle-page__breadcrumb">
          <span className="subtitle-page__breadcrumb-link" onClick={() => navigate("/settings")} style={{ cursor: "pointer" }}>Setting</span>
          <span className="subtitle-page__breadcrumb-separator">/</span>
          <span className="subtitle-page__breadcrumb-current">Subtitle</span>
        </div>

        {/* Two-column layout */}
        <div className="subtitle-page__content">
          {/* Left: Settings Card */}
          <div className="subtitle-page__card">
            {/* Font Selection */}
            <div className="subtitle-page__field">
              <label className="subtitle-page__label">Font</label>
              <select
                className="subtitle-page__select"
                value={font}
                onChange={(e) => setFont(e.target.value)}
              >
                <option>Sans serif</option>
                <option>Serif</option>
                <option>Monospace</option>
              </select>
            </div>

            {/* Font Size Selection */}
            <div className="subtitle-page__field">
              <label className="subtitle-page__label">Font size</label>
              <div className="subtitle-page__toggle-group">
                <button
                  className={`subtitle-page__toggle-btn ${
                    fontSize === "Small" ? "subtitle-page__toggle-btn--active" : ""
                  }`}
                  onClick={() => setFontSize("Small")}
                >
                  Small
                </button>
                <button
                  className={`subtitle-page__toggle-btn ${
                    fontSize === "Normal" ? "subtitle-page__toggle-btn--active" : ""
                  }`}
                  onClick={() => setFontSize("Normal")}
                >
                  Normal
                </button>
                <button
                  className={`subtitle-page__toggle-btn ${
                    fontSize === "Large" ? "subtitle-page__toggle-btn--active" : ""
                  }`}
                  onClick={() => setFontSize("Large")}
                >
                  Large
                </button>
              </div>
            </div>

            {/* Color Selection */}
            <div className="subtitle-page__field">
              <label className="subtitle-page__label">Set Color</label>
              <div className="subtitle-page__color-select">
                <span className="subtitle-page__color-dot" />
                <select
                  className="subtitle-page__select"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                >
                  <option>White</option>
                  <option>Yellow</option>
                  <option>Cyan</option>
                  <option>Black</option>
                </select>
              </div>
            </div>

            {/* Shadow Selection */}
            <div className="subtitle-page__field">
              <label className="subtitle-page__label">Shadow</label>
              <select
                className="subtitle-page__select"
                value={shadow}
                onChange={(e) => setShadow(e.target.value)}
              >
                <option>Drop shadow</option>
                <option>Outline</option>
                <option>None</option>
              </select>
            </div>

            {/* Action Buttons */}
            <div className="subtitle-page__actions">
              <button
                className="subtitle-page__btn subtitle-page__btn--outline"
                onClick={handleSave}
              >
                Save change
              </button>
              <button
                className="subtitle-page__btn subtitle-page__btn--filled"
                onClick={handleReset}
              >
                Reset to default
              </button>
            </div>
          </div>

          {/* Right: Preview Section */}
          <div className="subtitle-page__preview-section">
            <h3 className="subtitle-page__preview-label">Preview</h3>
            <div className="subtitle-page__preview-container">
              <div className="subtitle-page__preview-placeholder" />
              <p className="subtitle-page__preview-text">This is the example text</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default SubtitlePage;
